import React,{useState, useEffect} from "react";
import {Row, Col} from "react-bootstrap";
import axios from "axios";
import {useHistory} from "react-router-dom";
import HeaderInfluxs from "./headerInfluxs";

function ContraDetails() {
    const uriContraDetails = "https://bo.influxs.live/StraKingAPI00X/api/contract_detail";
    const uriContraKpi = "https://bo.influxs.live/StraKingAPI00X/api/contract_actionKPI";
    const uriPlatformKpi = "https://bo.influxs.live/StraKingAPI00X/api/actionsby_plateforms";
    const uriLastAction = "https://bo.influxs.live/StraKingAPI00X/api/last_actions";

    let history=useHistory();

    const [detailsContra, setDetailsContra] = useState({
        categoryLabel:"",
        companyName:"",
        images:"",
        label:"",
        nameInfluencer:"",
        scane:"",
        endDate:"",
        fullName:""});

    const [kpisObjectif, setKpisObjectif] = useState(null);
    const [kpisPlatform, setKpisPlatform] = useState(null);
    const [lastAction, setLastAction] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const contraId = localStorage.getItem('contraId');
        console.log(contraId);
        const api = axios.create({
            baseURL: uriContraDetails,
            headers: {'Authorization': 'Bearer ' + token}
        });
        getContraDetailsData();
        getContraKpiObjectif();
        getPlatformResult();
        getLastAction();

        async function getContraDetailsData() {
            api.get(uriContraDetails+"/"+contraId).then(
                res => {
                    console.log(res);
                    setDetailsContra({...detailsContra,
                        categoryLabel: res.data.category_label,
                        images: res.data.images,
                        fullName: res.data.full_name,
                        endDate: res.data.end_date,
                        scane: res.data.scane,
                        label: res.data.label});
                }
            ).catch(err => {

                alert(err.response.data.message);
            })

        }

        async function getContraKpiObjectif() {
            api.get(uriContraKpi+"/"+contraId).then(
                res => {
                    console.log(res);
                    setKpisObjectif(res.data);
                }
            ).catch(err => {

                alert(err.response.data.message);
            })

        }

        async function getPlatformResult() {
            api.get(uriPlatformKpi+"/"+contraId).then(
                res => {
                    console.log(res);
                    setKpisPlatform(res.data);
                }
            ).catch(err => {

                alert(err.response.data.message);
            })

        }

        async function getLastAction() {
            api.get(uriLastAction+"/"+contraId).then(
                res => {
                    console.log(res);
                    setLastAction(res.data);
                }
            ).catch(err => {

                alert(err.response.data.message);
            })

        }
    }, );

    return (
        <div className="contraDetail">
            <HeaderInfluxs/>
           <div className="list-of-contra-header">
               <Row>
                   <Col>
                    <span><img className="Avatar"
                               src={detailsContra.images}
                               alt=""/></span>&nbsp;&nbsp;
                       {detailsContra.fullName}&nbsp;<br/>
                       <div>Titre: {detailsContra.label}</div>
                       <div>Catégorie influenceur: {detailsContra.categoryLabel}</div>
                       <div>Date fin du contrat: {detailsContra.endDate}</div>
                   </Col>
                   <Col>
                       <div>KPI Effectué par l'influenceur</div>
                       {kpisObjectif && kpisObjectif.length > 0 ?  (
                           <div className="contra">
                               {kpisObjectif.map((contr, index) => (
                                   <div key={index} >
                                       <div className="UserInfo">
                                           <li className="list-of-contra">
                                               <span>{contr.kpi_label}</span>
                                               <span>{contr.kpi_actions}  / {contr.contract_kpi}</span>
                                           </li>
                                       </div>
                                   </div>

                               ))}

                           </div>
                       ) : <h1>...</h1>}
                   </Col>
                   <Col>
                       <div>Répartition par Réseaux social</div>
                       {kpisPlatform && kpisPlatform.length > 0 ?  (
                           <div className="contra">
                               {kpisPlatform.map((contr, index) => (
                                   <div key={index}>
                                       <div className="UserInfo">
                                           <li className="list-of-contra">
                                               <span>{contr.name}</span>
                                               <span>{contr.value}</span>
                                           </li>
                                       </div>
                                   </div>

                               ))}

                           </div>
                       ) : <h1>...</h1>}
                   </Col>
               </Row>
               <Row>
                   <Col><div>Les dernières actions</div></Col>
                   <Col><button className="button" onClick={() => {
                       history.push('/listOfAction');
                   }}>Voir plus d'action</button></Col>
                   <Col><button className="button" onClick={() => {
                       history.push('/createAction');
                   }}>Créer une action</button></Col>
               </Row>
               {lastAction && lastAction.length > 0 ?  (
                   <div className="contra">
                       {lastAction.slice(0, 3).map((contr, index) => (
                           <div key={index} onClick={() => {
                               localStorage.setItem('actionId', contr.id);
                               history.push('/actionDetails');
                           }}>
                               <div className="UserInfo">
                                   <li className="list-of-action">
                                       {/*<span><img className="icon"*/}
                                       {/*           src={contr.image}*/}
                                       {/*           alt=""/></span>*/}
                                       <span>Titre de l'action: {contr.text} <br/>
                                        <span>Type de publication: {contr.type}</span><br/>
                                        <span>Platforme: {contr.platform}</span><br/>
                                        <span>Date de publication: {contr.date_j}</span><br/>
                                    </span>
                                       <span>
                                        <button className="button" onClick={() => {
                                            localStorage.setItem('actionId', contr.id);
                                            history.push('/actionDetails');
                                        }}>voir plus</button>
                                    </span>

                                   </li>
                               </div>
                           </div>

                       ))}

                   </div>
               ) : <h1>...</h1>}
           </div>
        </div>
    )
}
export default ContraDetails;